module.exports = __webpack_public_path__ + "img/power-sharing-fr.dfc39685.png";